import script from "./sbh.vue?vue&type=script&setup=true&lang=js"
export * from "./sbh.vue?vue&type=script&setup=true&lang=js"

import "./sbh.vue?vue&type=style&index=0&id=8d9ec61e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d9ec61e"]])

export default __exports__